import React from 'react'
import styles from './styles.css'
import Loading from 'App/components/RouteLoading'

export default class Landing extends React.Component {
  static propTypes = {}

  render() {
    window.location = 'https://www.orionx.com'
    return (
      <div style={{backgroundColor: 'white'}}>
        <div className={styles.container}>
          <Loading />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Home/Landing/index.js